/**
 * ローカルストレージからデフォルトのステータスフィルタ値を取得
 */
export const DISPLAY_PROPERTY_FILTER_KEY = "display-property-filter-status";
export const displayPropertyFilterStatus = (): string[] => {
  const storageStatus = localStorage.getItem(DISPLAY_PROPERTY_FILTER_KEY);
  if (!storageStatus) return ["0", "1", "2", "3", "4", "5"];
  return JSON.parse(storageStatus);
};
